import { api } from '@/api/main.api'

export async function apiGetNotificationsToken () {
  return api('get', `/v3/platform-notification/init`)
}

export async function apiMarkAsReadNotifications (projectID) {
  return api('delete', `/v3/platform-notification/${projectID}`)
}



// WEBPACK FOOTER //
// ./src/api/messages.api.js